// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';

// Styles
import BlogPostHeaderStyles from './blogPostHeader.styles';

export default function BlogPostHeader({ title, categories, readingTime }) {
  return (
    <BlogPostHeaderStyles>
      <Container flex alignItems="center" justifyContent="center">
        {title && <h1 className="title">{title}</h1>}
      </Container>
      <Container flex alignItems="center" justifyContent="center">
        <ul className="categories">
          {!!categories?.nodes?.length &&
            categories.nodes.map((category) => (
              <li key={uuid()} className="category">
                {category?.name}
              </li>
            ))}
        </ul>
        <div className="meta">
          <p className="reading-time">{readingTime}</p>
        </div>
      </Container>
    </BlogPostHeaderStyles>
  );
}

BlogPostHeader.propTypes = {
  title: PropTypes.string.isRequired,
  readingTime: PropTypes.string,
  categories: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ),
  }),
};

BlogPostHeader.defaultProps = {
  readingTime: '',
  categories: {},
};
